/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import Footer from "../../../components/main/Footer"
import React from "react"
import { Col, Container } from "react-bootstrap"

export default function ClientPageFooter({ tunnelData }) {
  return (
    <Col sm={12}>
      <Container>
        <Footer tunnelData={tunnelData} />
      </Container>
    </Col>
  )
}
